import { render } from "./Privacy.vue?vue&type=template&id=34590e8b&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=34590e8b&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/PROD_AptokPromotion/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34590e8b"]])

export default __exports__